function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Crop Image"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Crop & Save Image"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Close"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { t } from "ttag";
import styled from "styled-components";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { checkeredBackground } from "../../styles";
import Loader, { URL_PROTOCOL_REGEXP } from "./Loader";
var DEFAULT_CROP_WIDTH = 50;
var DEFAULT_CROP_HEIGHT = 50;
var defaultCrop = {
    unit: "px",
    x: 0,
    y: 0,
    width: DEFAULT_CROP_WIDTH,
    height: DEFAULT_CROP_HEIGHT,
    aspect: null
};
var defaultRatio = {
    vertical: 1,
    horizontal: 1
};
export var useCrop = function() {
    var initialCrop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultCrop, initialRatio = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultRatio;
    var _useState = _slicedToArray(useState(initialCrop), 2), crop = _useState[0], setCrop = _useState[1];
    var _useState1 = _slicedToArray(useState(initialRatio), 2), ratios = _useState1[0], setRatios = _useState1[1];
    useEffect(function() {
        setCrop({
            unit: initialCrop.unit,
            x: initialCrop.x / ratios.horizontal,
            width: initialCrop.width / ratios.horizontal,
            y: initialCrop.y / ratios.vertical,
            height: initialCrop.height / ratios.vertical
        });
    }, [
        ratios,
        initialCrop
    ]);
    return {
        crop: crop,
        setCrop: setCrop,
        ratios: ratios,
        setRatios: setRatios
    };
};
var StyledReactCrop = styled(ReactCrop)(_templateObject(), checkeredBackground);
var ImageCrop = function(param) {
    var src = param.src, onCropSaveClick = param.onCropSaveClick, settings = param.settings, _param_maxHeight = param.maxHeight, maxHeight = _param_maxHeight === void 0 ? 0 : _param_maxHeight, _param_minHeight = param.minHeight, minHeight = _param_minHeight === void 0 ? 0 : _param_minHeight, _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? 0 : _param_maxWidth, _param_minWidth = param.minWidth, minWidth = _param_minWidth === void 0 ? 0 : _param_minWidth, visible = param.visible, onModalClose = param.onModalClose, _param_maskClosable = param.maskClosable, maskClosable = _param_maskClosable === void 0 ? false : _param_maskClosable, _param_circularCrop = param.circularCrop, circularCrop = _param_circularCrop === void 0 ? false : _param_circularCrop;
    // The initial state for cropImageUrl is null for showing the Loading Spin until the image
    // is fully loaded. Once the cropImageUrl is set, we have to observe 'src' - once it's changed
    // we have to show the spin again until the new image is also loaded.
    var _useState = _slicedToArray(useState(null), 2), url = _useState[0], setUrl = _useState[1];
    useEffect(function() {
        setUrl(null);
    }, [
        src
    ]);
    var _useCrop = useCrop(settings), crop = _useCrop.crop, setCrop = _useCrop.setCrop, ratios = _useCrop.ratios, setRatios = _useCrop.setRatios;
    var onOk = function() {
        var cropPayload = _objectSpreadProps(_objectSpread({}, crop), {
            x: crop.x * ratios.horizontal,
            width: crop.width * ratios.horizontal,
            y: crop.y * ratios.vertical,
            height: crop.height * ratios.vertical
        });
        if (onCropSaveClick) {
            onCropSaveClick(cropPayload);
        }
    };
    var onImageLoaded = function(image) {
        var height = image.height, width = image.width, naturalHeight = image.naturalHeight, naturalWidth = image.naturalWidth;
        setRatios({
            vertical: naturalHeight / height,
            horizontal: naturalWidth / width
        });
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        title: t(_templateObject1()),
        centered: true,
        closable: false,
        maskClosable: maskClosable,
        open: visible,
        onCancel: onModalClose,
        onOk: onOk,
        okText: t(_templateObject2()),
        okButtonProps: {
            disabled: !url
        },
        cancelText: t(_templateObject3())
    }, url ? /*#__PURE__*/ React.createElement(StyledReactCrop, {
        src: src,
        crop: crop,
        circularCrop: circularCrop,
        maxHeight: maxHeight ? maxHeight / ratios.vertical : undefined,
        minHeight: minHeight ? minHeight / ratios.vertical : undefined,
        maxWidth: maxWidth ? maxWidth / ratios.horizontal : undefined,
        minWidth: minWidth ? minWidth / ratios.horizontal : undefined,
        onChange: function(next) {
            // Force aspect ratio to 1 for circular crops
            if (circularCrop) {
                var size = Math.min(next.width, next.height);
                setCrop(_objectSpreadProps(_objectSpread({}, next), {
                    x: Math.max(0, next.x),
                    y: Math.max(0, next.y),
                    width: size,
                    height: size
                }));
            } else {
                setCrop(_objectSpreadProps(_objectSpread({}, next), {
                    // due to a bug in react-image-crop library, we receive negative values when
                    // cropping is started from the top-left corner.
                    // this may be a related bug
                    // https://github.com/DominicTobias/react-image-crop/issues/377
                    x: Math.max(0, next.x),
                    y: Math.max(0, next.y)
                }));
            }
        },
        onImageLoaded: onImageLoaded
    }) : /*#__PURE__*/ React.createElement(Loader, {
        src: src,
        onLoad: function() {
            return setUrl(src);
        }
    }));
};
ImageCrop.propTypes = {
    src: ({
        isRequired: function(props, propName, componentName) {
            if (!URL_PROTOCOL_REGEXP.test(props[propName])) {
                return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. Validation failed."));
            }
            return null;
        }
    }).isRequired
};
export default ImageCrop;
